



































































































































































































































































































































import ModalCreatePassCode from "@/components/modal/PassCode/ModalCreatePassCode.vue";
import ModalRemovePassCode from "@/components/modal/PassCode/ModalRemovePassCode.vue";
import ModalResetPassCode from "@/components/modal/PassCode/ModalResetPassCode.vue";
import ModalViewPassCode from "@/components/modal/PassCode/ModalViewPassCode.vue";
import ModalAlertPartnerNotConnect from "@/components/modal/Payment/ModalAlertPartnerNotConnect.vue";
import ModalConfirmPaymentFail from "@/components/modal/Payment/ModalConfirmPaymentFail.vue";
import ModalAlertIsNotAvailable from "@/components/modal/Payment/ModalAlertIsNotAvailable.vue";
import ModalConfirmPaymentSuccess from "@/components/modal/Payment/ModalConfirmPaymentSuccess.vue";
import ModalInfoToConfirmPaymentPaySolutions from "@/components/modal/Payment/ModalInfoToConfirmPaymentPaySolutions.vue";
import ModalInfoToConfirmPaymentBeam from "@/components/modal/Payment/ModalInfoToConfirmPaymentBeam.vue";
import ModalLoadingConfirmPayment from "@/components/modal/Payment/ModalLoadingConfirmPayment.vue";
import ModalMakePayment from "@/components/modal/Payment/ModalMakePayment.vue";
import {
  BillingNoteDatabaseStatus,
  ContactEnvelopePageSizeType,
  DebitNoteDatabaseStatus,
  DocumentType,
  DocumentUpdatePassCodeType,
  FinanceType,
  InvoiceDatabaseStatus,
  LoadingStatusType,
  Package,
  QRPaymentType,
  TransactionType,
  VerificationStatus,
} from "@/enums/enums";
import { GetPaperSizeName } from "@/helper/contactEnvelopeHelper";
import { GetMerchantNameWihtMerchantType } from "@/helper/merchantHelper";
import { CheckMerchantPackage } from "@/helper/userHelper";
import { ContactEnvelopeOnlineViewModel } from "@/model/document/contactEnvelopeModel";
import { DocumentGeneratePdfModel, DocumentIdModel, OnlineViewModel } from "@/model/document/documentModel";
import { JournalOnlineViewModel } from "@/model/document/journalDocumentModal";
import { PP30OnlineViewModel } from "@/model/document/pp30DocumentModel";
import { WitholdingTaxOnlineViewModel } from "@/model/document/witholdingTaxDocumentModal";
import { MerchantModel } from "@/model/merchant/merchantModel";
import { BeamRequestModel, DataBeamPaymentModel, GetTransactionRemainPaymentModel } from "@/model/payment/paymentModel";
import { UserModel } from "@/model/user/userModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { AllowToDownloadClientSide } from "../../helper/generatePdfHelper";
import MainNavBar from "./MainNavBar.vue";
import SwitchCurrency from "./SwitchCurrency.vue";
import { CheckIsMUZE } from "@/helper/shareHelper";

const isMUZE = CheckIsMUZE();
import SwitchlangHeader from "./SwitchlangHeader.vue";
import SelectDocumentType from "./SelectDocumentType.vue";
import { CheckIsCustomizeDocument, GetURLName } from "@/helper/documentHelper";
import { MerchantId } from "@/helper/authenticationHelper";

const StoreAuthentication = namespace("Authentication");
const StoreGeneratePdf = namespace("GeneratePdf");
const StoreDocument = namespace("Document");
const StorePayment = namespace("Payment");
const StoreMerchant = namespace("Merchant");

@Component({
  components: {
    MainNavBar,
    ModalViewPassCode,
    ModalResetPassCode,
    ModalRemovePassCode,
    ModalCreatePassCode,
    ModalMakePayment,
    ModalConfirmPaymentSuccess,
    ModalConfirmPaymentFail,
    ModalAlertPartnerNotConnect,
    ModalLoadingConfirmPayment,
    ModalInfoToConfirmPaymentPaySolutions,
    SwitchlangHeader,
    SwitchCurrency,
    SelectDocumentType,
    ModalInfoToConfirmPaymentBeam,
    ModalAlertIsNotAvailable,
  },
})
export default class Header extends Vue {
  @Prop({}) merchantDetail!: MerchantModel;
  @Prop({ default: false }) isAuthorized!: boolean;
  @Prop({ default: false }) isCanNotOpenDocument!: boolean;
  @Prop({ default: "" }) documentName!: string;
  @Prop({ default: "" }) transactionNumber!: string;
  @Prop({ default: 0 }) sourceType!: number;
  @Prop({ default: false }) isDocumentNameShort!: boolean;

  private blobUrl = process.env.VUE_APP_PeakBlobStorage;
  private profileDefualt: string =
    "https://peakblobstoragesit.blob.core.windows.net/peakengine/user/logo/logo_peak-default.png";
  private imgVersion = Date.now();
  private scrollOver: boolean = false;
  private widthScreen = 0;
  private countdownWaitingPayment = 0;
  private timeWaitingPayment = 30;
  private interval: any | null = null;
  private isShowHerderMenu = false;
  private isShowModalViewPassCode: boolean = false;
  private isShowModalResetPassCode: boolean = false;
  private isShowModalRemovePassCode: boolean = false;
  private isShowModalCreatePassCode: boolean = false;
  private isShowModalMakePayment: boolean = false;
  private isShowMakePayment: boolean = false;
  private isShowModalInfoToConfirmPaymentPaySolutions = false;
  private isShowModalInfoToConfirmPaymentBeam = false;
  private isShowModalConfirmPaymentSuccess = false;
  private isShowModalConfirmPaymentFail = false;
  private isShowModalAlertIsNotAvailable = false;
  private isShowModalLoadingConfirmPayment = false;
  private isMUZE = isMUZE;
  private isShowModalAlertPartnerNotConnect = false;
  private isSetShowModalMakePayment = false;
  private isValidatePackage = CheckMerchantPackage([Package.Free, Package.Basic, Package.Pro]);
  private isCustomize = CheckIsCustomizeDocument();
  private partnerName = "";

  @StoreAuthentication.Getter
  private getUserInfo!: UserModel | null;
  @StoreDocument.Getter
  private getDocumentDetail!:
    | OnlineViewModel
    | JournalOnlineViewModel
    | PP30OnlineViewModel
    | WitholdingTaxOnlineViewModel
    | ContactEnvelopeOnlineViewModel
    | null;
  @StoreDocument.Getter
  private getDocumentLoadingStatus!: LoadingStatusType;
  @StoreDocument.Getter
  private getDocumentPassCode!: string;
  @StoreDocument.Getter
  private getUpdateOnlineViewPassCodePrintPdfLoadingStatus!: LoadingStatusType;
  @StoreDocument.Getter
  private getIsCanSwitchCurrency!: boolean;
  @StoreDocument.Getter
  private getCustomizeIdList!: Array<any>;
  @StorePayment.Getter
  private getTransactionRemainPaymentLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getTransactionRemainPaymentModel!: any;
  @StorePayment.Getter
  private getIsConfirmPayment!: boolean;
  @StorePayment.Getter
  private getPaySolutionPaymentLoadingStatus!: LoadingStatusType;
  @StoreMerchant.Getter
  private getMerchantQRPaymentModel!: any;
  @StoreMerchant.Getter
  private getMerchantQRPaymentSettingLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getBeamPaymentLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getBeamPaymentModel!: DataBeamPaymentModel;

  @StoreGeneratePdf.Action
  private DoGeneratePdf!: (input: DocumentGeneratePdfModel) => void;
  @StoreGeneratePdf.Action
  private DoGeneratePdfClientSide!: (input: DocumentGeneratePdfModel) => void;
  @StoreGeneratePdf.Action
  private DoGeneratePdfLogService!: (input: DocumentGeneratePdfModel) => void;

  @StoreDocument.Action
  private DoUpdateOnlineViewPassCode!: (input: DocumentIdModel) => void;
  @StoreDocument.Action
  private DoSetUpdateOnlineViewPassCodePrintPdfLoadingStatus!: (status: LoadingStatusType) => void;
  @StorePayment.Action
  private DoGetTransactionRemainPayment!: (input: GetTransactionRemainPaymentModel) => void;
  @StoreMerchant.Action
  private DoGetQRPaymentSetting!: () => void;
  @StorePayment.Action
  private DoGetBeamPayment!: (input: BeamRequestModel) => void;

  created() {
    this.GetQRPaymentSetting();
  }

  get isSettingWithPassCode() {
    if (this.getDocumentDetail?.credential) {
      return this.getDocumentDetail?.credential.passCode !== "";
    }
    return false;
  }

  get isVerificationStatusSuccess() {
    return this.merchantDetail.verificationStatus === VerificationStatus.Success;
  }

  get merchantFullName() {
    if (this.merchantDetail) {
      return GetMerchantNameWihtMerchantType(this.merchantDetail.merchantType, this.merchantDetail.merchantName);
    }
    return "";
  }

  get isEnvelope() {
    return this.getDocumentDetail?.transactionType === DocumentType.Envelope;
  }

  get isDocumentOtherType() {
    return (
      this.getDocumentDetail?.transactionType === DocumentType.Envelope ||
      this.getDocumentDetail?.transactionType === DocumentType.ExecutiveSummary
    );
  }

  get isCanRedirectToOldPeak() {
    let isCanRedirectToOldPeak = true;
    switch (this.getDocumentDetail?.transactionType) {
      case DocumentType.DebitNote:
      case DocumentType.CreditNote:
      case DocumentType.WithholdingTax:
      case DocumentType.PP30:
      case DocumentType.Pnd1:
      case DocumentType.Pnd2:
      case DocumentType.Pnd3:
      case DocumentType.Pnd53:
      case DocumentType.ExecutiveSummary: {
        isCanRedirectToOldPeak = false;
      }
    }
    return isCanRedirectToOldPeak;
  }

  get isValidateQRPayment() {
    return this.getMerchantQRPaymentModel && this.getMerchantQRPaymentModel.qrPaymentTypeId > QRPaymentType.Bank;
  }

  get isCanPayment() {
    if (
      this.getDocumentDetail instanceof OnlineViewModel &&
      this.getTransactionRemainPaymentModel &&
      this.CheckOpenBtnPaidPayment(this.getDocumentDetail)
    ) {
      if (this.isValidateQRPayment && this.isValidatePackage) {
        return false;
      }
      return true;
    }
    return false;
  }

  get isShowDocumentName() {
    let isShowDocumentName = true;
    if (this.getCustomizeIdList && this.getCustomizeIdList.length > 0) {
      isShowDocumentName = false;
    }
    return isShowDocumentName;
  }

  @Watch("getDocumentLoadingStatus")
  getDocumentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.isShowMakePayment = false;
      if (
        (this.getDocumentDetail?.transactionType == TransactionType.Invoice ||
          this.getDocumentDetail?.transactionType == TransactionType.DebitNote ||
          this.getDocumentDetail?.transactionType == TransactionType.BillingNote) &&
        this.getDocumentDetail?.financeType === FinanceType.InFlow &&
        this.getDocumentDetail?.transactionId > 0 &&
        this.merchantDetail.isQrPayment
      ) {
        this.GetTransactionRemainPayment(
          this.getDocumentDetail?.transactionId,
          this.getDocumentDetail?.transactionType
        );
      }
    }
  }

  @Watch("getTransactionRemainPaymentLoadingStatus")
  getTransactionRemainPaymentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      if (this.getIsConfirmPayment) {
        this.isShowModalLoadingConfirmPayment = false;
        this.SetShowModalPaymentResponse();
      } else {
        this.SetIsShowMakePayment();
      }
    } else if (newVal === LoadingStatusType.Loading && this.getIsConfirmPayment) {
      this.isShowModalLoadingConfirmPayment = true;
    }
  }

  @Watch("getUpdateOnlineViewPassCodePrintPdfLoadingStatus")
  getUpdateOnlineViewPassCodePrintPdfLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.GeneratePdf();
      this.DoSetUpdateOnlineViewPassCodePrintPdfLoadingStatus(LoadingStatusType.None);
    }
  }

  @Watch("getPaySolutionPaymentLoadingStatus", { immediate: true })
  getPaySolutionPaymentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Fail) {
      this.CountdownWaitingPayment(this.timeWaitingPayment);
    }
  }

  @Watch("getMerchantQRPaymentSettingLoadingStatus")
  getMerchantQRPaymentSettingLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.SetIsShowModalMakePayment();
    }
  }

  @Watch("getBeamPaymentLoadingStatus")
  getBeamPaymentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      if (this.getBeamPaymentModel && this.getBeamPaymentModel.paymentLink) {
        window.open(this.getBeamPaymentModel.paymentLink, "_blank");
      } else {
        this.partnerName = "Beam Checkout";
        this.isShowModalAlertIsNotAvailable = true;
      }
    }
  }

  mounted() {
    this.widthScreen = window.innerWidth;
    window.addEventListener("resize", () => {
      this.widthScreen = window.innerWidth;
    });
    window.addEventListener("scroll", this.HandleScroll);
  }

  destroyed() {
    window.removeEventListener("scroll", this.HandleScroll);
    clearInterval(this.interval);
  }

  public GetQRPaymentSetting() {
    this.DoGetQRPaymentSetting();
  }

  public SetIsShowMakePayment() {
    if (
      (this.getDocumentDetail?.transactionType == TransactionType.Invoice ||
        this.getDocumentDetail?.transactionType == TransactionType.DebitNote ||
        this.getDocumentDetail?.transactionType == TransactionType.BillingNote) &&
      this.getDocumentDetail?.financeType === FinanceType.InFlow &&
      this.merchantDetail.isQrPayment
    ) {
      let paidTotal = this.getTransactionRemainPaymentModel.netAmount - this.getTransactionRemainPaymentModel.paidTotal;
      if (paidTotal > 0) {
        this.isShowMakePayment = true;
        this.CheckIsShowModalQrPayment();
      } else {
        this.isShowMakePayment = false;
      }
    }
  }

  public CheckOpenBtnPaidPayment(getDocumentDetail: OnlineViewModel) {
    let isCanGetData = false;

    if (
      getDocumentDetail != null &&
      getDocumentDetail.financeType == FinanceType.InFlow &&
      getDocumentDetail.transactionId > 0
    ) {
      const transactionType: number = getDocumentDetail.transactionType;
      const statusType: number = getDocumentDetail?.document.data.statusType;
      if (transactionType == TransactionType.Invoice && statusType >= InvoiceDatabaseStatus.OutstandingOrOverdue) {
        isCanGetData = true;
      } else if (transactionType == TransactionType.DebitNote && statusType >= DebitNoteDatabaseStatus.Approved) {
        isCanGetData = true;
      } else if (
        transactionType == TransactionType.BillingNote &&
        statusType >= BillingNoteDatabaseStatus.OutstandingOrOverdue
      ) {
        isCanGetData = true;
      }
    }

    return isCanGetData;
  }

  public SetShowModalPaymentResponse() {
    let paidTotal = this.getTransactionRemainPaymentModel.netAmount - this.getTransactionRemainPaymentModel.paidTotal;
    if (paidTotal > 0) {
      this.isShowModalConfirmPaymentFail = true;
    } else {
      this.isShowModalConfirmPaymentSuccess = true;
    }
  }
  public SetIsShowModalMakePayment() {
    if (
      this.getMerchantQRPaymentSettingLoadingStatus === LoadingStatusType.Success &&
      this.isSetShowModalMakePayment &&
      this.getDocumentDetail instanceof OnlineViewModel
    ) {
      if (this.merchantDetail.isQrPayment && this.getMerchantQRPaymentModel) {
        switch (this.getMerchantQRPaymentModel.qrPaymentTypeId) {
          case QRPaymentType.Bank:
          case QRPaymentType.SCB:
          case QRPaymentType.Bay:
          case QRPaymentType.Bbl:
            this.isShowModalMakePayment = true;
            break;
          case QRPaymentType.PaySolutions:
            this.isShowModalInfoToConfirmPaymentPaySolutions = true;
            break;
          case QRPaymentType.Beam:
            const postBackUrl = `${process.env.VUE_APP_PeakDocument}${GetURLName(
              this.getDocumentDetail?.transactionId,
              this.getDocumentDetail.financeType
            )}?emi=${MerchantId().PeakEncryption()}&eti=${this.getDocumentDetail.transactionId.PeakEncryption()}&etti=${this.getDocumentDetail.transactionType.PeakEncryption()}&efti=${this.getDocumentDetail.financeType.PeakEncryption()}`;

            this.GetBeamPayment(
              this.getDocumentDetail?.transactionId,
              this.getDocumentDetail.transactionType,
              postBackUrl
            );
            break;
        }
      } else {
        this.isShowModalAlertPartnerNotConnect = true;
      }
      this.isSetShowModalMakePayment = false;
    }
  }
  public GetBeamPayment(transactionId: number, transactionType: number, postBackUrl: string) {
    const input: BeamRequestModel = {
      transactionId: transactionId,
      transactionTypeId: transactionType,
      onlineViewUrl: postBackUrl,
    };
    this.DoGetBeamPayment(input);
  }
  public StartMakePayment() {
    this.isSetShowModalMakePayment = true;
    this.GetQRPaymentSetting();
  }
  public HandleScroll() {
    this.scrollOver = window.scrollY > 110;
  }
  public GetPaperSizeName(pageSize: ContactEnvelopePageSizeType) {
    return GetPaperSizeName(pageSize);
  }
  public RedirectToLogin() {
    window.open(process.env.VUE_APP_PeakAccount);
  }
  public GeneratePdfLogService() {
    let input: DocumentGeneratePdfModel = {
      transactionNumber: this.transactionNumber,
      documentName: this.documentName,
      isDocumentNameShort: this.isDocumentNameShort,
      passCode: "",
      transactionType: this.getDocumentDetail?.transactionType || TransactionType.None,
    };
    this.DoGeneratePdfLogService(input);
  }
  public PrintDocument() {
    this.GeneratePdfLogService();
    window.print();
  }
  public GetTransactionRemainPayment(
    transactionId: number,
    transactionType: TransactionType,
    isConfirmPayment = false
  ) {
    let input: GetTransactionRemainPaymentModel = {
      transactionId: transactionId,
      transactionType: transactionType,
      isConfirmPayment: isConfirmPayment,
    };
    this.DoGetTransactionRemainPayment(input);
  }
  public GeneratePdf() {
    const isClientSideGenerate: boolean = process.env.VUE_APP_CLIENT_GENERATE == 1 ? true : false;
    const allowToClientSideGenerate: boolean = AllowToDownloadClientSide(this.getDocumentDetail?.transactionType);

    let input: DocumentGeneratePdfModel = {
      transactionNumber: this.transactionNumber,
      documentName: this.documentName,
      isDocumentNameShort: this.isDocumentNameShort,
      passCode: "",
      transactionType: this.getDocumentDetail?.transactionType || TransactionType.None,
    };

    if (this.merchantDetail.isUsePassCodeOnPublicLink) {
      if (this.getUserInfo) {
        if (this.getDocumentPassCode === "" && this.getDocumentDetail) {
          let inputUpdatePassCode = {
            transactionType: this.getDocumentDetail.transactionType,
            financeType: this.getDocumentDetail.financeType,
            transactionId: this.getDocumentDetail.transactionId,
            documentUpdatePassCodeType: DocumentUpdatePassCodeType.PrintPdf,
            sourceType: this.sourceType,
          };
          this.DoUpdateOnlineViewPassCode(inputUpdatePassCode);
        } else {
          input.passCode = this.getDocumentPassCode;
          if (isClientSideGenerate && allowToClientSideGenerate) {
            this.DoGeneratePdfClientSide(input);
          } else {
            this.DoGeneratePdf(input);
          }
        }
      } else {
        input.passCode = this.getDocumentPassCode;
        if (isClientSideGenerate && allowToClientSideGenerate) {
          this.DoGeneratePdfClientSide(input);
        } else {
          this.DoGeneratePdf(input);
        }
      }
    } else {
      if (isClientSideGenerate && allowToClientSideGenerate) {
        this.DoGeneratePdfClientSide(input);
      } else {
        this.DoGeneratePdf(input);
      }
    }
  }

  public CheckIsShowModalQrPayment() {
    const isShowPayment = this.$route.query.isShowPayment;
    if (isShowPayment && Boolean(isShowPayment) == true) {
      this.StartMakePayment();
    }
  }

  public ConfirmPayment() {
    const isConfirmPayment = true;
    if (this.getDocumentDetail) {
      this.GetTransactionRemainPayment(
        this.getDocumentDetail.transactionId,
        this.getDocumentDetail.transactionType,
        isConfirmPayment
      );
    }
  }

  public CountdownWaitingPayment(duration: number) {
    let timer: number = duration;

    this.interval = setInterval(() => {
      this.countdownWaitingPayment = timer;

      if (--timer < 0) {
        this.timeWaitingPayment = 0;
        clearInterval(this.interval);
      }
    }, 1000);
  }
}
